import {Component, OnInit} from '@angular/core';
import {AuthService, BlockAbstractComponent, PageService, ParserService} from '@gallaghercp/core-frontend';
import {BreakpointObserver} from "@angular/cdk/layout";


@Component({
    selector: 'core-one-page-cta',
    templateUrl: './one-page-cta.component.html',
    styleUrls: ['./one-page-cta.component.scss'],
    standalone: false
})

export class OnePageCtaComponent extends BlockAbstractComponent implements OnInit {

    ctaTitle = 'Think about your wellbeing this year';
    ctaText = 'Lorem ipsum dolor sit amet consectetur. Donec imperdiet felis at volutpat. Ultrices urna ipsum placerat integer.';
    ctaButtonText = 'Watch Video'
    ctaBackgroundImageUrl = '/assets/img/cta_image.png';
    ctaBackgroundImageUrlMobile = '/assets/img/cta_image_mobile.png';

    showBackgroundImage: boolean = true;

    constructor(
        protected override parser: ParserService,
        protected override pages: PageService,
        protected override auth: AuthService,
        protected breakpoint: BreakpointObserver
    ) {
        super(
            parser,
            auth,
            pages,
        );

        this.breakpoint.observe([
            '(max-width: 768px)'
        ]).subscribe(result => {
            this.showBackgroundImage = !result.matches;
        });
    }

}
